<ms-form-field appearance="flat" color="lightAir">
<ms-select [(ngModel)]="value">
    <ms-option *ngFor="let language of languages; index as index" [value]="language">
    <span>{{ 'langs.' + ALPHABETS[language].code | translate }}</span>
    </ms-option>
</ms-select>
</ms-form-field>
